document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 768) {
    console.log("[GK Video] Skipping overlays on mobile");
    return;
  }
  function waitForVideos(attempts = 40) {
    const videos = document.querySelectorAll(".product-thumbnails-wrapper video");
    if (!videos.length) {
      if (attempts > 0) return setTimeout(() => waitForVideos(attempts - 1), 300);
      console.warn("[GK Video] No video elements found after waiting.");
      return;
    }

    console.log(`[GK Video] Found ${videos.length} video(s), injecting overlays...`);
    injectOverlays();
    observeThumbnails();
  }

  function observeThumbnails() {
    const gallery = document.querySelector(".product-thumbnails-wrapper");
    if (!gallery) return;
    const observer = new MutationObserver(() => injectOverlays());
    observer.observe(gallery, { childList: true, subtree: true });
  }

  function injectOverlays() {
    const thumbs = document.querySelectorAll(".product-thumbnails-wrapper li");

    thumbs.forEach((li) => {
      if (li.querySelector(".thumb-video-overlay")) return;

      const video = li.querySelector("video");
      if (!video) return;

      const posterSrc = video.getAttribute("poster") || "";

      // 🧠 skip overlays on size chart thumbnails
      if (posterSrc.includes("sizechart")) return;

      // Detect if this is an autoplay/loop video
      const wasAuto = video.hasAttribute("autoplay") || video.hasAttribute("loop");

      // Freeze playback and display only the first frame
      video.pause();
      video.removeAttribute("autoplay");
      video.removeAttribute("loop");
      video.currentTime = 3;
      video.style.pointerEvents = "none";
  

      // 🌀 Add the appropriate overlay (always 360° if was auto)
      const overlay = document.createElement("div");
      overlay.className = "thumb-video-overlay";
      overlay.innerHTML = wasAuto
        ? `<img src="//www.gkelite.com/cdn/shop/t/93/assets/icon-360.svg?v=103524877046612524271772810676" alt="360° View" />`
        : `<img src="//www.gkelite.com/cdn/shop/t/93/assets/icon-play.svg?v=136672280994089585861725469194" alt="Play Video" />`;

      li.style.position = "relative";

      overlay.style.cssText = `
      position: absolute;  top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 48px;
      height: 48px;
      z-index: 5;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      `;


      const icon = overlay.querySelector("img");
      icon.style.cssText = `
        width:100%;
        height:100%;
        opacity:0.9;
        transition:opacity 0.2s ease;
      `;

      li.appendChild(overlay);
    });
  }

  waitForVideos();
});
